<template>
    <div class="subscribe-container mt-5" v-if="formLoaded">
        <h3 v-html="stepTitles[step]"></h3>
        <form class="fields-container">
            <div v-if="step === 0">
                <div v-for="field in fields.slice(0, 2)" class="my-3" v-if="!field.hidden" :key="field.slug">
                    <Input
                      :field="field"
                      v-model="formValues[field.slug]"
                      :show_label="false"
                    />
                    <span class="error-label d-flex mt-1" v-html="errors[field.slug]"></span>
                </div>
            </div>
            <div v-else-if="step === 1">
                <div v-for="field in fields.slice(2)" class="my-3" v-if="!field.hidden" :key="field.slug">
                    <Input
                      :field="field"
                      v-model="formValues[field.slug]"
                      :show_label="false"
                    />
                    <span class="error-label d-flex mt-1" v-html="errors[field.slug]"></span>
                </div>
            </div>
        </form>
        <div v-if="loading" class="spinner-border text-light spinner-border-sm" role="status"></div>
        <button v-if="!loading && step !== 2" class="btn btn-primary mx-auto w-100" @click="changeStep()">{{ step === 1 ? 'Enviar': 'Siguiente'}}</button>
    </div>
</template>

<script>
import Input from './InputForm.vue'
import CaliforniaFormValidator from "@/components/mixins/CaliforniaFormValidator";
export default {
    mixins: [CaliforniaFormValidator],
    components: {
        Input
    },
    data() {
        return {
            formLoaded: false,
            formSlug: 'suscribete-a-nuestro-boletin',
            formValues: {},
            fields: [],
            form: {},
            step: 0,
            stepTitles: [],
            loading: false,
            errors: {}
        }
    },
    mounted() {
        this.getForm()
    },
    methods: {
        getForm() {
            this.$axios(`/api/v1/content/forms/${this.formSlug}`)
              .then(response => {
                  this.form = response.data.data
                  this.fields = this.form.config_json.fields
                  this.setFormTitles()
                  this.formLoaded = true
              })
              .catch(error => {
                  console.error(error)
              })
        },
        changeStep() {
            trackClick('suscribete','siguiente')
            if (this.step === 0) {
                let validForm = this.validateForm(this.fields.slice(0, 2), this.formValues)
                if (!validForm) return
                this.step = 1
            } else {
                let validForm = this.validateForm(this.fields.slice(2), this.formValues)
                if (!validForm) return
                this.submitForm()
            }
        },
        submitForm() {
            let loading = true
            let validForm = this.validateForm(this.fields, this.formValues)
            if (!validForm) {
                this.loading = false
                return
            }

            let formData = {...this.formValues}
            formData.form_slug = this.form.slug
            formData.boletin = true
            this.$axios.post('/api/submitForm', {data: {data: formData}})
              .then(response => {
                  if (response.data.data.success)
                      this.step = 2
              })
              .catch(error => {
                  console.error(error)
              }).finally(() => {
                this.loading = false
            })
        },
        setFormTitles() {
            this.stepTitles = [
              this.form.title,
              "Ahora ingresa tu nombre y apellido(s)",
              "Felicidades ahora estarás recibiendo las últimas novedades de Presta Prenda a tu correo electrónico"
            ]
        }
    }
}
</script>

<style>
.subscribe-container {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    padding: 1rem;
}

.subscribe-container h3 {
    font-size: 1rem;
    max-width: 100%;
    overflow: hidden;
    font-weight: bolder;
    color: var(--prestaprenda-orange);
    text-transform: uppercase;
    margin-bottom: 1rem;
}

.subscribe-container label, .subscribe-container .checkbox-input label {
    color: black !important;
    font-size: 10px;
}

.subscribe-container .checkbox-input {
    align-items: flex-start;
}

.subscribe-container input {
    border-radius: 0;
    height: 30px;
    border: 1px solid lightgrey !important;
    font-size: 12px;
}

.subscribe-container ::placeholder {
    font-size: 10px;
}

.subscribe-container button {
    font-size: 12px !important;
}

.subscribe-container .error-label {
    font-size: 10px;
}
</style>